import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LinkItem } from 'src/app/shared/models';
import { LoggerService } from 'src/app/core/logger.service';
import { DialogWrapper } from 'src/app/shared/services/DialogWrapper';
import { DirtyOutService } from 'src/app/core/crypt/dirty-out.service';
import { LinkListService } from 'src/app/links/services/link-list.service';

@Component({
  selector: 'app-link-info-dialog',
  templateUrl: './link-info-dialog.component.html',
  styleUrls: ['./link-info-dialog.component.scss'],
})
export class LinkInfoDialogComponent
  extends DialogWrapper<LinkInfoDialogComponent, { link: LinkItem }, string>
  implements OnInit, OnDestroy
{
  public modalText = 'Preparing...';
  public isEnced = false;
  public total = 0;
  public finished = 0;
  public isComponentActive = true;
  public isDialogOpen = false;

  constructor(
    public override dialogRef: MatDialogRef<LinkInfoDialogComponent, string>,
    @Inject(MAT_DIALOG_DATA) public override matDialogData: { link: LinkItem },
    private dirtyOutService: DirtyOutService,
    private loggerService: LoggerService,
    private linkListService: LinkListService,
  ) {
    super();
  }

  public async ngOnInit(): Promise<void> {
    this.isDialogOpen = true;
    if (this.matDialogData?.link) {
      await this.linkListService.encryptLink(
        this.matDialogData.link,
        (progress: number) => this.updateModalText(progress),
        () => this.isComponentActive,
      );
      this.modalText = 'Finalizing Link, Please wait...';
      this.isEnced = true;
      this.isDialogOpen = false;
    }
  }

  private async encLink(): Promise<void> {
    const link = this.matDialogData.link;
    this.total = link.cnt + link.enc_cnt;
    this.finished = link.enc_cnt;

    this.updateModalText(this.calcProgress());

    while (this.finished < this.total && this.isComponentActive) {
      const data = await this.dirtyOutService.executeForShare(link.share_id);

      if (!data || (Array.isArray(data) && data.length === 0)) {
        this.finished = this.total;
        this.updateModalText(100);
        break;
      }

      if (data && data.completed) {
        this.finished += data.completed;
        const percentage = this.calcProgress();
        this.updateModalText(percentage);

        if (this.finished >= this.total) {
          this.updateModalText(100);
          break;
        }
      }
    }

    this.modalText = 'Finalizing Link, Please wait...';
    this.isEnced = true;
    this.loggerService.info('post link action completed');
    this.isDialogOpen = false;
  }

  private calcProgress(): number {
    return Math.min(Math.round((this.finished / this.total) * 100), 100);
  }

  private updateModalText(progress: number): void {
    this.modalText = `Encrypting link ${progress}%, Please wait...`;
  }

  public ngOnDestroy(): void {
    this.isComponentActive = false;
  }
}
